module.exports = __webpack_public_path__ + "media/application/images/2018/icon-recommended-1310b2b2dc78da2acdceda4939fb1a79.svg";